import React from 'react';

import { FieldRadioButton } from '../../../components';

import css from './SignupUserType.module.css';
import { accountTypes } from '../../utils/accountTypes';

const SignupUserType = ({ _inProgress, _invalid, formId }) => (
  <div>
    <div style={{ marginTop: '10px', fontFamily: 'Roboto, Helvetica, Arial, sans-serif' }}>
      <br />
      <span>User type</span>
    </div>
    <div className={css.fourColumnLayout}>
      <div className={css.column}>
        <FieldRadioButton
          id={formId ? `${formId}.expert` : 'expert'}
          name="accountType"
          label="Mentor"
          value={accountTypes.mentor}
        />
      </div>
      <div className={css.column}>
        <FieldRadioButton
          id={formId ? `${formId}.student` : 'student'}
          name="accountType"
          label="Student"
          value={accountTypes.student}
        />
      </div>
    </div>
  </div>
);

export default SignupUserType;
